<template>
  <div>
    <v-flex
      offset-lg1
      offset-xl1
      class="flex-margin"
    >
      <v-card>
        <v-card-title
          class="card-title v-card-scroll"
          color="black"
        >
          {{ $t('NavigationSideBar.registry') }}
          <v-spacer />
          <v-icon
            v-if="mobileBreakpoints()"
            color="red"
            size="28"
            @click="$router.push('/')"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-overlay :value="overlay">
          <v-progress-circular
            indeterminate
            size="64"
          />
        </v-overlay>
        <v-form
          ref="appUserForm"
          v-model="valid"
          class="pa-4"
          lazy-validation
        >
          <v-row class="title mt-4 mb-4">
            {{ $t('NavigationSideBar.personalData') }}
          </v-row>
          <v-row>
            <v-col class="d-flex align-center">
              <v-text-field
                v-model="app_user.username"
                label="Username"
                required
                disabled
                class="flex-grow-1"
              />
              <v-btn
                small
                outlined
                color="RMprimary"
                class="ml-4"
                @click="changePassDialog = true"
              >
                <v-icon class="mr-2">
                  mdi-form-textbox-password
                </v-icon>
                {{ $t('Password.changePassword') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="app_user.app_user_data[0]._name"
                :rules="name_rules"
                :label=" $t('AppUserForm.name')"
                required
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="app_user.app_user_data[0].surname"
                :rules="name_rules"
                :label="$t('AppUserForm.surname')"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="app_user.app_user_data[0].email"
                label="E-mail"
                required
                :disabled="true"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="app_user.app_user_data[0].phone"
                :rules="phoneRules"
                :label="$t('AppUserForm.phone')"
              />
            </v-col>
          </v-row>
          <v-row class="title mt-4 mb-4">
            {{ $t('NavigationSideBar.settings') }}
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="app_user.app_user_data[0].language"
                :items="items"
                item-value="language"
                item-text="language"
                :label="$t('AppUserForm.language')"
                :rules="language_rules"
                dense
              />
            </v-col>
            <v-col>
              <v-select
                v-model="app_user.app_user_data[0].user_map_style"
                :items="mapStyles"
                :value="mapStyles.value"
                :label="$t('AppUserForm.userMapStyle')"
                :clearable="app_user.app_user_data[0].user_map_style !== ''"
                dense
              />
            </v-col>
          </v-row>
          <v-spacer />
          <div>
            <v-btn
              color="success"
              class="mr-4"
              @click="submit"
            >
              {{ $t('AppUserForm.submit') }}
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-flex>

    <!-- DIALOG CHANGE PASSWORD -->
    <v-dialog
      v-model="changePassDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('Password.changePassword') }}
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="passFormValid"
            lazy-validation
          >
            <v-text-field
              v-model="currentPassword"
              :label="$t('Password.currentPassword')"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              required
              @click:append="togglePasswordVisibility"
            />

            <v-text-field
              v-model="newPassword"
              :label="$t('Password.newPassword')"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              :rules="[
                pass_rules.required,
                pass_rules.min,
                pass_rules.hasNumber,
                pass_rules.hasSpecial,
                pass_rules.hasUpper,
                pass_rules.hasLower
              ]"
              required
              @click:append="togglePasswordVisibility"
            />

            <v-text-field
              v-model="confirmPassword"
              :label="$t('Password.confirmPassword')"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              :rules="[pass_rules.required, matchPassword]"
              required
              @click:append="togglePasswordVisibility"
            />
          </v-form>
          <v-alert
            v-if="feedback"
            :type="feedback.type"
            dense
            text
            class="mt-2"
          >
            {{ feedback.message }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="red"
            @click="closeDialog"
          >
            {{ $t('Password.cancel') }}
          </v-btn>
          <v-btn
            :dark="passFormValid"
            color="RMprimary"
            :disabled="!passFormValid || overlay"
            @click="savePassword"
          >
            {{ $t('Password.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { loadLanguageAsync } from '@/plugins/i18n.js';
import { MAP_STYLES } from '@/constants.js';
import { Auth } from 'aws-amplify';
import {
  required,
  manageLenghtError,
  getRegExp
} from '@/formRules.js';

export default {
  data() {
    return {
      items: [{
        id: 0,
        language: '' },
      {
        id: 1,
        language: 'IT' },
      {
        id: 2,
        language: 'EN' }

      ],
      mapStyles: [{ text: 'Default', value: '' }, ...MAP_STYLES],
      valid: true,
      overlay: false,
      name_rules: [...required, ...manageLenghtError(255)],
      phone_rules: [...getRegExp('phone_number')],
      language_rules: [...required],
      appUserForm: {
        username: '',
        _name: '',
        surname: '',
        email: '',
        phone: '',
        language: '',
        user_map_style: ''
      },
      changePassDialog: false,
      passFormValid: false,
      showPassword: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      pass_rules: {
        required: v => !!v || this.$t('Password.required'),
        min: v => (!v || v.length >= 8) || this.$t('Password.min'),
        hasNumber: v => (!v || /\d/.test(v)) || this.$t('Password.hasNumber'),
        hasSpecial: v => (!v || /[!@#$%^&*(),.?":{}|<>_\-\\[\];'/+=~`]/.test(v)) || this.$t('Password.hasSpecial'),
        hasUpper: v => (!v || /[A-Z]/.test(v)) || this.$t('Password.hasUpper'),
        hasLower: v => (!v || /[a-z]/.test(v)) || this.$t('Password.hasLower')
      },
      feedback: null
    };
  },
  computed: {
    ...mapState(['app_user', 'map']),
    phoneRules() {
      if (!this.appUserForm.phone) {
        return [!this.appUserForm.phone];
      } else {
        return this.phone_rules;
      }
    }
  },
  async created() {
    await this.storeAppUser(this.app_user.app_user_id);
  },
  methods: {
    ...mapActions(['storeAppUser', 'storeUpdatedAppUser', 'storeToastMessage']),
    async submit() {
      this.overlay = true;
      this.appUserForm.app_user_id = this.app_user.app_user_id;
      this.appUserForm.username = this.app_user.username;
      this.appUserForm._name = this.app_user.app_user_data[0]._name;
      this.appUserForm.surname = this.app_user.app_user_data[0].surname;
      this.appUserForm.email = this.app_user.app_user_data[0].email;
      this.appUserForm.phone = this.app_user.app_user_data[0].phone;
      this.appUserForm.language = this.app_user.app_user_data[0].language;
      this.appUserForm.user_map_style = this.app_user.app_user_data[0].user_map_style;
      await this.storeUpdatedAppUser(this.appUserForm);
      await this.storeAppUser(this.app_user.app_user_id);
      this.map.mapStyle = this.app_user.app_user_data[0].user_map_style || this.app_user.app_user_data[0].map_style;
      await loadLanguageAsync(this.appUserForm.language.toLowerCase());
      this.map.mapLocale = this.appUserForm.language.toLowerCase() === 'it' ? 'Italian' : 'English';
      this.map.MBmap.setLanguage(this.map.mapLocale);
      this.overlay = false;
    },
    isLandscape() {
      return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight < window.innerWidth;
    },
    mobileBreakpoints() {
      return /Mobi|Android/i.test(navigator.userAgent) || this.isLandscape();
    },
    matchPassword(v) {
      return v === this.newPassword || this.$t('Password.passwordsNotMatch');
    },
    closeDialog() {
      this.changePassDialog = false;
      this.showPassword = false;
      this.feedback = null;
      this.$refs.form.reset();
    },
    async savePassword() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.overlay = true;
      this.feedback = null;

      try {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.changePassword(user, this.currentPassword, this.newPassword);

        this.storeToastMessage({
          text: this.$t('Password.passwordChanged'),
          type: 'success'
        });

        this.closeDialog();
      } catch (error) {
        let msg = this.$t('Password.unknownError');

        if (error.code === 'NotAuthorizedException') {
          msg = this.$t('Password.passwordIncorrect');
        } else if (error.code === 'InvalidPasswordException') {
          msg = this.$t('Password.passwordInvalid');
        } else if (error.code === 'LimitExceededException') {
          msg = this.$t('Password.limitExceeded');
        }

        this.feedback = { type: 'error', message: msg };
      } finally {
        this.showPassword = false;
        this.overlay = false;
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style scoped>
.title-color {
  color: #0ca344;
}
.viewMargin {
  margin-left: 10em !important;
}
.description-color {
  color: #3d3d3d;
}
.flex-margin {
  margin-right: 2%;
  margin-top: 2%
}
@media (max-device-width:600px){
  .form {
    padding-left: 5%;
    padding-right: 5%;
  }
}
.div-width {
  width: 300px;
}
.card-title {
  color: #0da344;
  background-color: #f4f3f3;
  font-size: 22px;
}
.card {
  margin-right:5%;
}
.row {
  margin: 0px!important;
}
</style>
